import React from "react"
import { motion } from "framer-motion"

const toneClasses = {
    primary: "text-white hover:opacity-90 focus-visible:ring-primeColor/30",
    secondary: "bg-slate-100 text-slate-700 border border-slate-200 hover:bg-slate-200 hover:border-slate-300 focus-visible:ring-slate-300/60",
    danger: "bg-[#c44545] text-white hover:bg-[#a93535] focus-visible:ring-[#c44545]/25",
}
const toneStyles = {
    primary: { background: 'linear-gradient(135deg,#0A1628,#112240)', color: '#F5D264', boxShadow: '0 4px 18px rgba(10,22,40,0.3)' },
}

const Button = ({ injectClass = "", type = "primary", children, onClick, disabled = false }) => {
    const trigger = () => {
        if (!disabled && typeof onClick === "function") onClick()
    }

    return (
        <motion.button
            whileTap={disabled ? {} : { scale: 0.98 }}
            type="button"
            disabled={disabled}
            onClick={trigger}
            style={toneStyles[type] || {}}
            className={[
                "inline-flex min-h-[46px] items-center justify-center gap-2 rounded-2xl px-5 py-3 text-sm font-bold tracking-[0.02em] shadow-soft transition duration-200",
                "focus-visible:outline-none focus-visible:ring-4",
                disabled ? "cursor-not-allowed opacity-55 shadow-none" : "cursor-pointer",
                toneClasses[type] || toneClasses.primary,
                injectClass,
            ].join(" ")}
        >
            {children}
        </motion.button>
    )
}

export default Button
